import { ShowSection } from 'framework/ui/layout';
import ProjectTeamList from './ProjectTeamList';
import { EditableListFormShowTemplate } from 'framework/list';

const ProjectTeamListLayout = () => {
  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
      <EditableListFormShowTemplate listSource="team.expectedStructure">
        <ProjectTeamList />
      </EditableListFormShowTemplate>
    </ShowSection>
  );
};

export default ProjectTeamListLayout;
